import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { IcFileAlt, IcInfo, IcCalc, IcSave } from "../../../Icons";
import { Button, Form, FormGroup, Label, Input, Row, Col, Badge } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function GastosGeneralCreate() {
  const { user }               = useContext(AuthContext);
  const URL_LOGS               = process.env.REACT_APP_URL_LOGS;
  const URL_GASTOS_GENERAL     = process.env.REACT_APP_URL_GASTOS_GENERAL;
  const URL_CONCEPTOS_GASTOS   = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;

  const hoy = moment(new Date()).format("YYYY-MM-DD");

  const [fecha,            setFecha]            = useState(hoy);
  const [subtotal,         setSubtotal]         = useState(0);
  const [iva,              setIva]              = useState(0);
  const [total,            setTotal]            = useState(0);
  const [descripcion,      setDescripcion]      = useState("NA");
  const [conceptosGastos,  setConceptosGastos]  = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");
  const [validaBoton,      setValidaBoton]      = useState(true);

  useEffect(() => {
    axios
      .get(URL_CONCEPTOS_GASTOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setConceptosGastos(res.data))
      .catch(() => {});
  }, []);

  const calcula = (e) => {
    setSubtotal(e);
    setTotal(parseFloat(e || 0) + parseFloat(iva || 0));
  };

  const calculaIVA = (e) => {
    setIva(e);
    setTotal(parseFloat(subtotal || 0) + parseFloat(e || 0));
  };

  const saveGasto = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_GASTOS_GENERAL,
        { fecha, subtotal, iva, total, descripcion, conceptosGastos: selectedConcepto, aplicado: "No" },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Crear Gasto", detalle: `Fecha: ${fecha} / Concepto: ${selectedConcepto} / Total: ${total}`, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        Swal.fire("¡Listo!", "Gasto registrado con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
        setValidaBoton(true);
      });
  };

  const fmtMXN = (n) =>
    "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(Number(n) || 0);

  return (
    <>
      <Header />
      <br />
      {user.menu_gastos ? (
        <div className="card container col-sm-9">

          {/* ── Page header ──────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcFileAlt style={{ marginRight: 8, color: "#f59e0b" }} />
                Nuevo Gasto
              </h3>
              <p className="page-subtitle">Registra un gasto general en el sistema</p>
            </div>
          </div>

          <Form onSubmit={saveGasto}>

            {/* ── Sección 1: Información del Gasto ─────────────────── */}
            <div className="form-section">
              <div className="form-section-header">
                <IcInfo />
                <span className="form-section-title">Información del Gasto</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Fecha</Label>
                      <Input
                        type="date"
                        value={fecha}
                        required
                        onChange={(e) => setFecha(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Concepto</Label>
                      <Input
                        type="select"
                        required
                        value={selectedConcepto}
                        onChange={(e) => setSelectedConcepto(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {conceptosGastos
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => (
                            <option key={a._id} value={a._id}>{a.name}</option>
                          ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={5}>
                    <FormGroup>
                      <Label>Descripción</Label>
                      <Input
                        type="text"
                        placeholder="Descripción del gasto"
                        value={descripcion}
                        required
                        onChange={(e) => setDescripcion(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>

            {/* ── Sección 2: Importes ──────────────────────────────── */}
            <div className="form-section">
              <div className="form-section-header dark">
                <IcCalc />
                <span className="form-section-title">Importes</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Subtotal</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        placeholder="0.00"
                        value={subtotal}
                        required
                        onChange={(e) => calcula(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>IVA</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        placeholder="0.00"
                        value={iva}
                        required
                        onChange={(e) => calculaIVA(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Total</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        placeholder={total}
                        disabled
                        style={{ background: "#f0fdf4", fontWeight: 700, color: "#15803d" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>

            {/* ── Total bar ────────────────────────────────────────── */}
            <div className="total-bar">
              <span>Total del Gasto</span>
              <Badge color="warning" className="BadgeSize badge-pill" style={{ color: "#78350f" }}>
                {fmtMXN(total)}
              </Badge>
            </div>

            {/* ── Submit ───────────────────────────────────────────── */}
            <div className="submit-bar">
              <Button type="submit" color="success" disabled={!validaBoton}>
                <IcSave style={{ marginRight: 6 }} />
                Guardar Gasto
              </Button>
            </div>

          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default GastosGeneralCreate;
